import { Fragment, useContext } from 'react';

import { createPortal } from 'react-dom';

import { ROOT_ELEMENT_ID } from '@skillarea/lib-shared';
import { ModalContext } from './ModalContext';
import { ModalLayerContext } from './ModalLayerContext';

const MODAL_ROOT_ID = `${ROOT_ELEMENT_ID}-modal-root`;
const RADIX_PORTAL_ATTRIBUTE = 'data-radix-portal';

function markAsRadixPortal(element: HTMLElement): HTMLElement {
  element.setAttribute(RADIX_PORTAL_ATTRIBUTE, '');
  return element;
}

export function ensureModalPortalRoot(): HTMLElement | null {
  if (typeof globalThis.document === 'undefined') {
    return null;
  }

  const existingRoot = globalThis.document.getElementById(MODAL_ROOT_ID);
  if (existingRoot instanceof HTMLElement) {
    return markAsRadixPortal(existingRoot);
  }

  const modalRoot = markAsRadixPortal(globalThis.document.createElement('div'));
  modalRoot.id = MODAL_ROOT_ID;
  globalThis.document.body.appendChild(modalRoot);
  return modalRoot;
}

export const ModalRoot = () => {
  const { currents } = useContext(ModalContext);
  const modalRoot = ensureModalPortalRoot();

  if (!modalRoot || currents.length === 0) return null;

  return createPortal(
    currents.map(({ component, layer }) => (
      <ModalLayerContext.Provider key={layer} value={layer}>
        <Fragment>{component}</Fragment>
      </ModalLayerContext.Provider>
    )),
    modalRoot,
  );
};
